import React, { FC } from 'react';
import { Container } from '@material-ui/core';

const NotFound: FC = () => (
  <Container maxWidth="md">
    <h4>Not Found</h4>
    <p>お探しのページは存在しません</p>
  </Container>
);

export default NotFound;
